import { render, staticRenderFns } from "./PropertyDetails.vue?vue&type=template&id=75a299b6&"
import script from "./PropertyDetails.vue?vue&type=script&lang=js&"
export * from "./PropertyDetails.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports